import qs from 'qs'
import React from 'react'
import { Bulk } from '../../components/bulk/bulk'
import { get } from '../../components/helpers/Api'

const BulkPage = (props) => {
    return <Bulk {...props} />
}

BulkPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    const values = qs.parse(paths[paths.length - 1].replace('bulk?', ''))

    values['search_page'] = true
    values['searchType'] = values['search_type']
        ? values['search_type']
        : 'bulk_sell'

    if (values['collection'] && values['collection'] !== '*')
        values['collection_details'] = await get(
            'collection-minimal/' + values['collection'],
            'legacy',
        )

    return values
}

export default BulkPage
